import React from 'react';

/** 정기결제 재시도 횟수·마지막 오류(토스 코드:메시지 등) 표시 */
export function SubscriptionPaymentNoteCell({ subscription }) {
  const rc = subscription.retryCount || 0;
  const err = subscription.lastRetryError;
  if (!rc && !err) {
    return <span style={{ color: '#999', fontSize: 14 }}>-</span>;
  }
  return (
    <div style={{ textAlign: 'left', maxWidth: 280, margin: '0 auto' }}>
      {rc > 0 && (
        <div style={{ fontSize: 12, fontWeight: 600, color: '#e65100', marginBottom: err ? 4 : 0 }}>
          재시도 {rc}회
        </div>
      )}
      {err && (
        <div
          style={{
            fontSize: 12,
            color: '#c62828',
            lineHeight: 1.45,
            maxHeight: 72,
            overflow: 'hidden',
            wordBreak: 'break-word',
          }}
          title={err}
        >
          {err}
        </div>
      )}
    </div>
  );
}
